import { MenuItem, Select, SelectChangeEvent } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { TbIcon } from 'components/Figma';

interface TablePaginationProps {
  page: number;
  rowsPerPage: number;
  totalCount: number;
  onPageChange: (event: unknown, newPage: number) => void;
  onRowsPerPageChange: (event: SelectChangeEvent<number>) => void;
  rowsPerPageOptions?: number[];
  rowsPerPageLabelId?: string;
}

export function TablePagination({
  page,
  rowsPerPage,
  totalCount,
  onPageChange,
  onRowsPerPageChange,
  rowsPerPageOptions = [10, 25, 50],
  rowsPerPageLabelId = 'api_access.token.rows_per_page',
}: TablePaginationProps) {
  const isFirstPage = page === 0;
  const isLastPage = page >= Math.ceil(totalCount / rowsPerPage) - 1;

  return (
    <div className="flex justify-end items-center pt-4 pr-2 gap-2 text-sm text-text-primary">
      <span>
        <FormattedMessage id={rowsPerPageLabelId} />
      </span>
      <Select
        value={rowsPerPage}
        onChange={onRowsPerPageChange}
        variant="outlined"
        size="small"
        sx={{
          '& .MuiSelect-icon': { width: 12, height: 12 },
          '& .MuiSelect-iconOpen': { transform: 'rotate(180deg)' },
          '& .MuiOutlinedInput-notchedOutline': { borderColor: '#e6e6e6' },
          '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: '#1a1a1a' },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: '#1a1a1a' },
        }}
      >
        {rowsPerPageOptions.map(option => (
          <MenuItem key={option} value={option}>
            {option}
          </MenuItem>
        ))}
      </Select>
      <button
        onClick={e => onPageChange(e, page - 1)}
        disabled={isFirstPage}
        aria-label="previous page"
        className="p-1 rounded hover:bg-gray-100 disabled:opacity-30 disabled:cursor-not-allowed"
      >
        <TbIcon name="ChevronLeft" size="sm" />
      </button>
      <span>{`${page * rowsPerPage + 1}-${Math.min((page + 1) * rowsPerPage, totalCount)} of ${totalCount}`}</span>
      <button
        onClick={e => onPageChange(e, page + 1)}
        disabled={isLastPage}
        aria-label="next page"
        className="p-1 rounded hover:bg-gray-100 disabled:opacity-30 disabled:cursor-not-allowed"
      >
        <TbIcon name="ChevronRight" size="sm" />
      </button>
    </div>
  );
}
